<template>
  <div id="app" :route="$route.name">
    <app-header></app-header>
    <div class="contenedor-view">
      <router-view class="view" />
    </div>
    <app-footer></app-footer>


  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  

  export default {
    name: 'App',
    components: {
      'app-header': header,
      'app-footer': footer,
      
    },
    mounted() {
      this.waypoints();


      setTimeout(e => {
        $(".cky-consent-bar").addClass("show");
        $("#cky-btn-accept").on("click", e => {
          this.$gtm.enable(true);
          this.$gtm.trackView(this.$route.name, this.$route.fullPath);
        });
      }, 2000);

  


    },
    methods: {
      waypoints: function () {

        var waypoints = document.getElementsByClassName('waypoints');



        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset: '80%',
            handler: function () {
              var element = this.key.split('-')[1];
              var effect = this.element.attributes.getNamedItem('effect');
              (effect != undefined) ? effect = effect.value : effect = "animate__fadeIn";
              this.element.classList.add("animate__animated", effect)
            }
          });

        }

      }
    },
    watch: {
      '$route'() {
        this.waypoints();
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/animaciones.scss';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import './assets/css/slick.css';
  @import "splitting/dist/splitting.css";
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Roboto:ital,wght@0,300;0,500;0,700;1,300&Amatic+SC:wght@700&display=swap');

  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.1/animate.css);
</style>


// WEBPACK FOOTER //
// src/App.vue